import { Badge, BadgeProps, Color, Text } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductOccupancyState, titleForProductOccupancyState } from 'zens-store'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  unknown: {
    color: Color.metalGrey,
  },
})

interface Props extends Omit<BadgeProps, 'status'> {
  value?: ProductOccupancyState
}
const Occupancy = (props: Props) => {
  const { value, ...otherProps } = props
  const { t } = useTranslation()
  const title = titleForProductOccupancyState(value, t)

  switch (value) {
    case ProductOccupancyState.Free:
      return <Badge title={title} status="success" {...otherProps} />
    case ProductOccupancyState.Occupied:
      return <Badge title={title} status="error" {...otherProps} />
    default:
      return <Text style={styles.unknown}>{title}</Text>
  }
}

export default Occupancy
